import { get } from '../Services/http';

const rootRoute = '/api/mypages/pricelabels';

export const getPriceLabels = (articleNumber) => {
  return get(`${rootRoute}/generate/${articleNumber}`).then((response) =>
    response.json()
  );
};
